<template>
    <b-container fluid>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="3" class="my-1 ml-0">
                <b-form-group class="ml-0 mb-0" label="Account:" label-cols-md="3">
                    <b-input-group size="sm" class="ml-0">
                        <b-form-select v-model="account" :options="accountoptions" @change="logacc">
                            <template v-slot:first>
                                <option value="">-- none --</option>
                            </template>
                        </b-form-select>

                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5">

            </b-col>
            <b-col md="3" class="my-1">
                <b-form-group
                        label="Filter"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                >
                    <b-input-group size="sm">
                        <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <br>

        <!-- Main table element -->
        <b-table
                show-empty
                small
                striped
                stacked="md"
                :items="trans"
                :busy="isBusy"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :tbody-tr-class="rowClass"
                :filter="filter"
                :filterIncludedFields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
        >

            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>

            <template v-slot:cell(nename)="row">
                <template v-if="row.item.nename">
                    {{ row.item.nename.substring(0, 15)}}
                </template>
            </template>

            <template v-slot:cell(craccountname)="row">
                <template v-if="row.item.craccountname">
                    {{ row.item.craccountname.substring(0, 15)}}
                </template>
            </template>

            <template v-slot:cell(amount)="row">
                {{ row.item.amount | toCurrency }}
            </template>

            <template v-slot:cell(serial)="row">
                {{ row.index + 1 }}
            </template>

            <template v-slot:cell(actions)="row">
                <b-button  size="xs" @click="deleteTran(row.item)" class="mr-1">
                    <template v-if="deleteloading">
                        <span  class="spinner-border spinner-border-sm mg-r-5" role="status" aria-hidden="true"></span>
                    </template>
                    Delete
                </b-button>
                <b-button size="xs" @click="row.toggleDetails">
                    {{ row.detailsShowing ? 'Hide' : 'Show' }} Account
                </b-button>
            </template>

            <template v-slot:row-details="row">
                <b-card>
                    <ul>
                        <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                    </ul>
                </b-card>
            </template>
        </b-table>

        <b-row>
            <b-col md="3" class="my-1 ml-0">
                <b-form-group
                        label="Per page"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="perPageSelect"
                        class="mb-0"
                >
                    <b-form-select
                            v-model="perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="pageOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="5"></b-col>
            <b-col sm="4" md="4" class="my-1 mr-0">
                <b-pagination
                        v-model="currentPage"
                        :total-rows="this.ft.transactions.length"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>

        <!-- Info modal -->
        <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
            <pre>{{ infoModal.content }}</pre>
        </b-modal>
    </b-container>
</template>

<script>
    import { mapState } from "vuex"
    export default {
        props:['items', 'isBusy', 'accounts'],
        data() {
            return {
                account: {},
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15, 20],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },
              fields: [
                {key: 'serial', label: 'Serial', sortable: true, class: 'text-left'},
                {key: 'creditbankcode', label: 'Bank Code', sortable: true, class: 'text-left'},
                {key: 'creditbankname', label: 'Bank Name', sortable: true, class: 'text-left'},
                {key: 'creditaccount', label: 'Account No', sortable: true, class: 'text-left'},
                {key: 'craccountname', label: 'BeneficiaryName', sortable: true, class: 'text-left'},
                {key: 'amount', label: 'Amount', sortable: true, class: 'text-left'},
                {key: 'nename', label: 'Validation Name', sortable: true, class: 'text-left'},
                {key: 'status', label: 'Validation Status', sortable: true, class: 'text-left'},
                {key: 'actions', label: 'Actions'}
              ]
            }
        },

        computed: {
            ...mapState(['ft']),
            accountoptions(){
                return this.$store.state.account.accountoption
            },
            deleteloading(){
                return this.$store.state.ft.deleteloader
            },
            trans(){
                return this.$store.state.ft.transactions
            },
            batchdetails(){
                return this.$store.state.ft.batchDetails
            }
        },
        components:{
        },
        mounted() {
            this.totalRows = this.items.length
        },
        methods: {
            logacc: function(){
                this.$store.commit("account/UPDATE_CURRENT_ACCOUNT", this.account);
            },
            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`;
                this.infoModal.content = JSON.stringify(item, null, 2);
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            resetInfoModal() {
                this.infoModal.title = '';
                this.infoModal.content = ''
            },
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1
            },
            rowClass(item, type) {
                if (!item || type !== 'row') return;
                if (item.status === 'invalid' && item.status != null) return 'table-danger';
                if(item.nestatus === 'success' && (item.craccountname.toLowerCase() !== item.nename.toLowerCase())) return 'table-primary';
                if (item.nestatus === 'success') return 'table-success';
                if (item.nestatus == null) return ;
            },

            deleteTran: async function(row){
                if (row.statusdescription == null){
                    await this.$store.commit('ft/REMOVE_SINGLE_TRANS', row.creditaccount)
                }else{

                    let res = await this.$store.dispatch("ft/deleteTransaction", {transactionid: row.id}, {root: true});
                    //console.log(res);
                    await this.$store.dispatch("ft/readBatchStatus", {batchid: this.$store.state.ft.batchDetails.batchid}, {root: false});
                    const trans = await this.$store.dispatch("ft/readBatchTransactions", {
                        batchref: this.batchdetails.batchid
                    }, {root: true});
                    await this.$store.commit('ft/UPDATE_TRANSACTIONS', trans.trasactions)
                    this.$swal({
                        title: res.responsecode === "00" ? 'Success' : 'Error',
                        showClass: {
                            popup: 'animated slideInLeft faster display-6'
                        },
                        hideClass: {
                            popup: 'animated slideOutRight faster display-6'
                        },
                        text: res.responsemessage,
                        icon: res.responsecode === "00" ? 'success' : 'warning',
                        showCancelButton: false,
                        confirmButtonText: 'Ok'
                    });
                }

                // let items = this.ft.transactions;
                // items.splice(_id,1);
                //this.$store.commit("ft/updateTransactions", items)
            }
        }
    }
</script>


<style scoped>
    td:first-letter {
        text-transform:capitalize;
    }
</style>
